import { Http, Response, Headers } from '@angular/http';
import { environment } from 'environments/environment';
import { Observable } from 'rxjs/Observable';

export class CoreService {

    private server: string;
    public token: string;
    private headers: Headers;
    private http: Http;

    /**
     * Clase con metodos basicos, requiere un parametro para que funcionen todos sus metodos
     * @param http Componente de angular, es necesario para generar las peticiones
     */
    constructor(http?: Http) {
        this.http = http || null;
        // if (environment.production) {
        //     this.server = 'http://jessie.acya.cl';
        // } else {
        //     this.server = 'http://localhost:8000/api';
        // }
        this.server = environment.server;
        this.token = localStorage.getItem('token');
        this.headers = new Headers({ 'Content-Type': 'application/x-www-form-urlencoded' });
        this.headers.append('token', this.getToken());
    }


    /**
     * Genera un link para las consultas http que se realizan
     * @param pagina link de la ruta que se quiere generar
     */
    public setUrl(pagina: string): string {
        return this.server + '/' + pagina;
    }


    /**
     * Establece un nuevo server donde realizar las peticiones http
     * @param server Ruta del server
     */
    public setServer(server: string): this {
        this.server = server;
        return this;
    }


    /**
     * Devuelve el server donde se realizan las peticiones http
    */
    public getServer(): string {
        return this.server;
    }


    /**
     * Crea las cabeceras para enviar en las peticiones http
     * @param news Objeto con las cabeceras nuevas
     */
    public setHeaders(news: Object = null): this {
        let headers = new Headers(news);
        headers.append('token', this.getToken());
        return this;
    }


    /**
     * Devuelve las cabeceras listas para utilizarlas en una peticion http
    */
    public getHeaders(): Headers {
        return this.headers;
    }


    /**
     * Establece un nuevo token para ser enviado en las peticiones http
     * @param token Token del usuario
     */
    public setToken(token: string): this {
        this.token = token;
        return this;
    }


    /**
     * Devuelve el token que se utiliza en las peticiones http
    */
    public getToken(): string {
        try {
            if (this.token == null) {
                throw new Error('El token no se ha definido.');
            }
            return this.token;
        } catch (e) {
        }
    }


    /**
     * Da formato a los datos para poder enviarse en una peticion http
     * @param parametros Objeto o arreglo con los datos que seran enviados en una peticion de http
     */
    public params(parametros: any): string {
        let params: string = 'json=' + JSON.stringify(parametros);
        return params;
    }


    /**
     * Metodo POST del protocolo http, se utiliza para insertar datos
     * @param ruta Ruta de la peticion http
     * @param data Datos que seran enviados en la peticion http
     * @param headers Cabeceras de la peticion http, por defecto siempre manda el token del usuario
     */
    public postMethod(ruta: any, data: any, headers?: Headers): Observable<any> {
        return this.http.post(
            this.setUrl(ruta),
            this.params(data),
            {
                headers: this.getHeaders()
            }
        ).map(res => res.json());
    }


    /**
     * Metodo GET del protocolo http, se utiliza para buscar datos
     * @param ruta Ruta de la peticion http
     */
    public getMethod(ruta: any): Observable<any> {
        return this.http.get(
            this.setUrl(ruta),
            {
                headers: this.getHeaders()
            }
        ).map(res => res.json());
    }


    /**
     * Metodo PUT del protocolo http, se utiliza para realizar actualizaciones
     * @param ruta Ruta de la peticion http
     * @param data Datos que seran enviados en la peticion http
     * @param headers Cabeceras de la peticion http, por defecto siempre manda el token del usuario
     */
    public putMethod(ruta: string, data: any, headers?: Headers): Observable<any> {
        return this.http.put(
            this.setUrl(ruta),
            this.params(data),
            {
                headers: this.getHeaders()
            }
        ).map(res => res.json());
    }


    /**
     * Metodo DELETE del protocolo http, se utiliza para eliminar datos
     * @param ruta Ruta de la peticion http
     * @param headers Cabeceras de la peticion http, por defecto siempre manda el token del usuario
     */
    public deleteMethod(ruta: string, headers?: Headers): Observable<any> {
        return this.http.delete(
            this.setUrl(ruta),
            {
                headers: this.getHeaders()
            }
        ).map(res => res.json());
    }
}


// WEBPACK FOOTER //
// ./src/app/services/entidades/core.service.ts